module.exports = __webpack_public_path__ + "media/images/tekstil4d-c0d0f9ef.svg";